import ConfirmDialog from "@/components/confirm-dialog";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { useSettlementId } from "@/modules/projects/hooks/useSettlementId";
import { closeProjectSettlement } from "@/modules/projectSettlements/service/projectSettlements";
import { useQueryClient } from "@tanstack/react-query";
import { LockIcon } from "lucide-react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";

export const SettlementCloseButton = () => {
  const { t } = useTranslation();
  const settlementId = useSettlementId();

  const { toast } = useToast();
  const queryClient = useQueryClient();

  const mutation = useMutationWithErrorHandling({
    errorTitle: t("projectSettlements.errors.close"),
    mutationFn: closeProjectSettlement,
    onSuccess: () => {
      toast({
        title: t("projectSettlements.success.close"),
      });
      queryClient.invalidateQueries({
        queryKey: [Module.ProjectSettlements, settlementId],
      });
    },
  });

  const onConfirm = useCallback(() => {
    mutation.mutateAsync(settlementId);
  }, [mutation, settlementId]);

  return (
    <ConfirmDialog
      title={t("projectSettlements.close.title")}
      content={t("projectSettlements.close.content")}
      onConfirm={onConfirm}
    >
      <Button variant="ghost" disabled={mutation.isPending}>
        {mutation.isPending ? (
          <Spinner />
        ) : (
          <LockIcon className="w-4 h-4 mr-1" />
        )}
        {t("projectSettlements.close.trigger")}
      </Button>
    </ConfirmDialog>
  );
};
